import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";

import './../styles/project.css';


const Projects =() =>{
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
    useEffect(() => {
      fetch('https://inkochetkov.github.io/data/projects.json') 
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          setData(data);
          setLoading(false);
        })
        .catch(error => {
          setError(error);
          setLoading(false);
        });
    }, []);
  
    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error.message}</div>;

    return (
    <>  
        <Helmet>
            <title>Портфолио</title>
            <meta name="description" content="Список реализованных проектов"/>
        </Helmet>

     <div className="main">
        <ul className="grids">
            {data.map((item) => 
            <li className="grids_item">
                <div className="grid">
                    <div className="grid_image">
                        <img src={`https://inkochetkov.github.io/${item.img}`} alt="img" />
                        <div className="grid_content">   
                            <h2 className="grid_title">{item.type}</h2>
                            <p className="grid_text">{item.name}</p>                                   
                            <a href={`/project/${item.name}`}   data-title ="Больше информации" style={{color:'white'}}>Больше информации</a>                      
                        </div> 
                    </div>
                </div>
            </li>)}
        </ul>
        </div>  
       
    </>
    );
}

export default Projects;